__turbopack_context__.v({
  "contentWrapper": "BlockProductHero-module-scss-module__p_7_NG__contentWrapper",
  "eyebrowBlock": "BlockProductHero-module-scss-module__p_7_NG__eyebrowBlock",
  "flushBottom": "BlockProductHero-module-scss-module__p_7_NG__flushBottom",
  "flushTop": "BlockProductHero-module-scss-module__p_7_NG__flushTop",
  "heroImgBlock": "BlockProductHero-module-scss-module__p_7_NG__heroImgBlock",
  "img": "BlockProductHero-module-scss-module__p_7_NG__img",
  "inner": "BlockProductHero-module-scss-module__p_7_NG__inner",
  "innerWrapper": "BlockProductHero-module-scss-module__p_7_NG__innerWrapper",
  "innerWrapperInner": "BlockProductHero-module-scss-module__p_7_NG__innerWrapperInner",
  "logoBlock": "BlockProductHero-module-scss-module__p_7_NG__logoBlock",
  "logoWrapper": "BlockProductHero-module-scss-module__p_7_NG__logoWrapper",
  "root": "BlockProductHero-module-scss-module__p_7_NG__root",
  "textBlock": "BlockProductHero-module-scss-module__p_7_NG__textBlock",
  "textOnRight": "BlockProductHero-module-scss-module__p_7_NG__textOnRight",
});
